<div class="adv" [class.adv--open]="expanded" [class.adv--active]="activeCount > 0">
    <button type="button"
            class="adv-bar"
            (click)="toggle()"
            [attr.aria-expanded]="expanded">
        <span class="adv-bar-icon"><i class="fa fa-sliders" aria-hidden="true"></i></span>
        <span class="adv-bar-title">Ricerca avanzata</span>
        <span *ngIf="activeCount > 0" class="adv-bar-count">{{ activeCount }}</span>

        <span *ngIf="!expanded && activeCount > 0" class="adv-bar-summary">
            <ng-container *ngFor="let text of summary; let last = last">
                <span class="adv-chip" [title]="text">{{ text }}</span>
                <span *ngIf="!last" class="adv-join">{{ joinLabel }}</span>
            </ng-container>
        </span>
        <span *ngIf="!expanded && activeCount === 0" class="adv-bar-hint">Combina più campi con E / O</span>

        <i class="fa adv-bar-chevron"
           [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
           aria-hidden="true"></i>
    </button>

    <div *ngIf="expanded" class="adv-body">
        <div *ngIf="state.rules.length > 1" class="adv-match">
            <span class="adv-match-label">Mostra i risultati che soddisfano</span>
            <div class="adv-segment" role="group" aria-label="Logica di combinazione">
                <button type="button"
                        [class.is-active]="state.match === 'and'"
                        (click)="setMatch('and')">
                    <strong>E</strong> tutte le condizioni
                </button>
                <button type="button"
                        [class.is-active]="state.match === 'or'"
                        (click)="setMatch('or')">
                    <strong>O</strong> almeno una condizione
                </button>
            </div>
        </div>

        <div class="adv-rules">
            <ng-container *ngFor="let rule of state.rules; let i = index; trackBy: trackById">
                <div *ngIf="i > 0" class="adv-join-row">
                    <span class="adv-join-pill">{{ joinLabel }}</span>
                </div>

                <div class="adv-rule">
                    <select class="form-control form-white adv-field"
                            [ngModel]="rule.field"
                            (ngModelChange)="onFieldChange(rule, $event)"
                            aria-label="Campo">
                        <option *ngFor="let field of fields" [value]="field.key">{{ field.label }}</option>
                    </select>

                    <select class="form-control form-white adv-operator"
                            [ngModel]="rule.operator"
                            (ngModelChange)="onOperatorChange(rule, $event)"
                            aria-label="Operatore">
                        <option *ngFor="let operator of operatorsOf(rule)" [value]="operator.value">{{ operator.label }}</option>
                    </select>

                    <div *ngIf="inputsOf(rule) > 0 && fieldOf(rule) as field" class="adv-values">
                        <ng-container [ngSwitch]="field.type">
                            <select *ngSwitchCase="'select'"
                                    class="form-control form-white"
                                    [ngModel]="rule.value"
                                    (ngModelChange)="onValueChange(rule, $event)"
                                    aria-label="Valore">
                                <option value="" disabled>Seleziona…</option>
                                <option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option>
                            </select>

                            <input *ngSwitchCase="'date'"
                                   type="date"
                                   class="form-control form-white"
                                   [ngModel]="rule.value"
                                   (ngModelChange)="onValueChange(rule, $event)"
                                   aria-label="Data">

                            <input *ngSwitchCase="'number'"
                                   type="text"
                                   inputmode="decimal"
                                   class="form-control form-white"
                                   placeholder="Valore"
                                   [ngModel]="rule.value"
                                   (ngModelChange)="onValueChange(rule, $event)"
                                   aria-label="Valore">

                            <input *ngSwitchDefault
                                   type="text"
                                   class="form-control form-white"
                                   placeholder="Valore"
                                   [ngModel]="rule.value"
                                   (ngModelChange)="onValueChange(rule, $event)"
                                   aria-label="Valore">
                        </ng-container>

                        <ng-container *ngIf="inputsOf(rule) === 2">
                            <span class="adv-and">e</span>
                            <input *ngIf="field.type === 'date'"
                                   type="date"
                                   class="form-control form-white"
                                   [ngModel]="rule.valueTo"
                                   (ngModelChange)="onValueToChange(rule, $event)"
                                   aria-label="Data finale">
                            <input *ngIf="field.type !== 'date'"
                                   type="text"
                                   inputmode="decimal"
                                   class="form-control form-white"
                                   placeholder="Valore"
                                   [ngModel]="rule.valueTo"
                                   (ngModelChange)="onValueToChange(rule, $event)"
                                   aria-label="Valore finale">
                        </ng-container>
                    </div>
                    <div *ngIf="inputsOf(rule) === 0" class="adv-values adv-values--none"></div>

                    <button type="button"
                            class="adv-remove"
                            (click)="removeRule(rule)"
                            title="Rimuovi condizione"
                            aria-label="Rimuovi condizione">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </ng-container>
        </div>

        <div class="adv-footer">
            <button type="button" class="adv-add" (click)="addRule()">
                <i class="fa fa-plus" aria-hidden="true"></i> Aggiungi condizione
            </button>
            <button *ngIf="state.rules.length > 0" type="button" class="adv-reset" (click)="reset()">
                Azzera
            </button>
        </div>
    </div>
</div>
